import { Form, InputGroup } from "react-bootstrap";
import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils.js";
import intlTelInput from "intl-tel-input";
import "./Inputfield.css";
import { useContext, useEffect } from "react";
import { TicketContext } from "../../store/ticket-context";
import { useState } from "react";
import { DomainDataContext } from "../../store/domaindata-context";
import { allowedCountriesDialCodePattern } from "../../constants/constants";

const SmsForm = (props) => {
  // const [eneteredPhone, setEnteredPhone] = useState({
  //   phone: "",
  //   country: "+1",
  //   isocode: "us",
  //   fullVal: "",
  //   isValidnumber: false,
  // });
  const [smsInputval, setSmsInputval] = useState(false);

  const ticket = useContext(TicketContext);
  const domainData = useContext(DomainDataContext);
  let smsinput;
  let eneteredPhone = {
    phone: "",
    country: "+1",
    isocode: "us",
    fullVal: "",
    isValidnumber: false,
  };

  useEffect(() => {
    // console.error(ticket);
    if (domainData !== null) {
      eneteredPhone = {
        phone: eneteredPhone.phone,
        country: domainData.data.ISOCODE,
        isocode: domainData.data.COUNTRYCODE.toLocaleLowerCase(),
        fullVal: eneteredPhone.phone,
        isValidnumber: false,
      };
      console.error("after domain");
      console.error(eneteredPhone);
      // setEnteredPhone(eneteredPhone);
      props.sendSMSnumber(eneteredPhone);
    }
    console.error(ticket);
    if (ticket !== null) {
      eneteredPhone = {
        phone: ticket.phone,
        country: eneteredPhone.country,
        isocode: eneteredPhone.isocode,
        fullVal: ticket.phone,
        isValidnumber: false,
      };
      if (ticket.phone.trim().length > 1) {
        eneteredPhone.isValidnumber = true;
      }
      console.error("after ticket");
      console.error(eneteredPhone);
      // setEnteredPhone(eneteredPhone);
      props.sendSMSnumber(eneteredPhone);
    }
    console.error("set obj");

    smsinput = document.getElementById("smsinput");
    setSmsInputval(smsinput);
    console.error("after ticket 2");
    console.error(eneteredPhone);
    window.smsiti = intlTelInput(smsinput, {
      autoHideDialCode: true,
      separateDialCode: false,
      formatOnDisplay: true,
      utilsScript: "./utils.js",
    });
    var phoneNumber = ''
    if (eneteredPhone.phone.trim().length > 1) {
       phoneNumber = eneteredPhone.phone;
      var patternMob = /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi;
      var isnonvalid = patternMob.test(phoneNumber);
      if (isnonvalid) {
        phoneNumber = phoneNumber.replace(
          /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi,
          ""
        );
        smsinput.value = phoneNumber;
        eneteredPhone.isValidnumber = false;
      } else {
        eneteredPhone.isValidnumber = true;
      }

      var matchedCountryCode = phoneNumber.match(
        allowedCountriesDialCodePattern
      );
      if (matchedCountryCode && matchedCountryCode.length > 0) {
        // window.smsiti.setNumber(phoneNumber);
        let newNumber = phoneNumber.substring(matchedCountryCode[0].length);
        phoneNumber = newNumber;
        console.error(newNumber);
        var countryData = window.intlTelInputGlobals.getCountryData();
        console.error(countryData);
        for (var i = 0; i < countryData.length; i++) {
          if (countryData[i].dialCode == matchedCountryCode[1]) {
            eneteredPhone.isocode = countryData[i].iso2;
            eneteredPhone.country = countryData[i].dialCode;
          }
        }

        eneteredPhone.phone = newNumber;
      } else {
        // window.smsiti.setNumber(phoneNumber);
      }
    }
    // window.smsiti.setNumber(eneteredPhone.phone);
    window.smsiti.setCountry(eneteredPhone.isocode);
    if(phoneNumber.length > 0){
      window.smsiti.setNumber(phoneNumber);
    }
   
    // setEnteredPhone(eneteredPhone);
    console.log(domainData.data.COUNTRYCODE);
    props.sendSMSnumber(eneteredPhone);
  }, [domainData, ticket]);

  const handleOnChange = (event) => {
    var countryData = window.smsiti.getSelectedCountryData();

    var phoneNumber = smsInputval.value;
    var patternMob = /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi;
    var isnonvalid = patternMob.test(phoneNumber);
    if (isnonvalid) {
      phoneNumber = phoneNumber.replace(
        /[a-zA-Z`~!@$%^&_|\=?;:'" ,<>\{\}\\\/]/gi,
        ""
      );
      smsInputval.value = phoneNumber;
    }

    var matchedCountryCode = phoneNumber.match(allowedCountriesDialCodePattern);
    if (matchedCountryCode && matchedCountryCode.length > 0) {
      window.smsiti.setNumber(phoneNumber);
      window.smsiti.setNumber(
        phoneNumber.substring(matchedCountryCode[0].length)
      );
    }
    if (typeof window.intlTelInputUtils !== "undefined") {
      // utils are lazy loaded, so must check
      var currentText = window.smsiti.getNumber(
        window.intlTelInputUtils.numberFormat.E164
      );
      if (typeof currentText === "string") {
        // sometimes the currentText is an object :)
        window.smsiti.setNumber(currentText); // will autoformat because of formatOnDisplay=true
      }
    }

    eneteredPhone = {
      phone: phoneNumber.trim(),
      country: countryData.dialCode,
      isocode: countryData.iso2,
      fullVal: window.smsiti.getNumber().trim(),
      isValidnumber: false,
    };
    if (window.smsiti.getNumber().trim()) {
      if (window.smsiti.isValidNumber()) {
        eneteredPhone.isValidnumber = true;
      }
    }
    // setEnteredPhone(enteredVal);
    console.log(eneteredPhone);
    console.log(countryData);
    props.sendSMSnumber(eneteredPhone);
  };

  return (
    <div>
      <div className="invite-help-text">
        Select the country and enter the guest's mobile number to send an
        invitation.
      </div>
      <Form.Group className="mx-3 mb-3" controlId="formBasicsms">
        <InputGroup>
          <input
            type="text"
            id="smsinput"
            onChange={handleOnChange}
            onBlur={handleOnChange}
            onFocus={handleOnChange}
            className="form-control"
            placeholder="Mobile Number"
          />
        </InputGroup>
      </Form.Group>
    </div>
  );
};

export default SmsForm;
